<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="$route.path" :collapse="collapse" unique-opened :background-color="bgColor" text-color="#fff" :active-text-color="ThemeColor" router>
            <template v-for="item in Menu">
                <template v-if="item.subs">
                    <el-submenu :index="item.id" :key="item.id" v-if="item.subs.length>0">
                        <template slot="title">
                            <i :class="[ 'iconfont', item.icon ]"></i><span slot="title">{{ getLangMenu(item.title) }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-menu-item :index="subItem.path" :disabled="subItem.disabled || false" :key="subItem.id">
                                {{ getLangMenu(subItem.title) }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.path" :disabled="item.disabled || false" :key="item.id">
                        <i :class="[ 'iconfont', item.icon ]"></i><span slot="title">{{ getLangMenu(item.title) }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLangMenu } from '@/utils/getLangDict'
import { MachineMenu } from '@/menuConfig'
import bus from "@/utils/bus";
import config from '@/config'
export default {
    name: "vSidebar",
    data() {
        return {
            collapse: false,
            Menu: [],
			list:[],
            ThemeColor: "#ffd06c",
            bgColor: "rgb(41, 61, 110)",     //  左侧导航背景色
        };
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on("collapse", msg => {
            this.collapse = msg;
        });
        // this.fmtMenu();
    },
    computed: {
        ...mapGetters(["projectInfo", "roles", "user",'projectsystemInfo'])
    },
	watch: {
		projectsystemInfo(newVal){
			this.getMenu(newVal.sys_type_id);
		}
	},
    methods: {
        getLangMenu,
		getMenu(sys_type_id) {
		    this.list = this.newMenu(MachineMenu, sys_type_id);
			this.fmtMenu(this.list)
		},
        fmtMenu(v) {
            if(this.user.usertype == 4) {
                 let roles = JSON.parse(JSON.stringify(this.roles))
                let newMenu = this.filterMenu(v, roles)
                this.Menu = newMenu
				
            }else{
                this.Menu = v
            }
        },
        filterMenu(menus, roles) {
            const accessedMenu = menus.filter(v => {
                if (this.hasMenuPermission(roles, v)) {
                    if (v.subs && v.subs.length) {
                        v.subs = this.filterMenu(v.subs, roles)
                    }
                    return true
                }
                return false
            })
            return accessedMenu
        },
        // 通过role左侧菜单
        hasMenuPermission(roles, menuItem) {
            if (menuItem.role) {
                return roles.indexOf(menuItem.role) >= 0
            } else {
                return true
            }
        },
		newMenu(menus, sys_type_id) {
		    const accessedMenu = menus.filter(v => {
		        if (this.newPermission(sys_type_id, v)) {
		            if (v.subs && v.subs.length) {
		                v.subs = this.newMenu(v.subs, sys_type_id)
		            }
		            return true
		        }
		        return false
		    })
		    return accessedMenu
		},
		newPermission(sys_type_id, v) {
		    if (v.system) {
		        return v.system.indexOf(sys_type_id) >= 0
		    } else {
		        return true
		    }
		}
    },
};
</script>

<style scoped lang="less">
.sidebar {
    height: 100%;
    text-align: left;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 180px;
}
.sidebar > ul {
    height: 100%;
}
.el-submenu [class^="iconfont"],
.el-menu-item [class^="iconfont"] {
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 16px;
    color: #fff;
}
.el-submenu .el-menu-item{
    min-width: 180px;
}
</style>